
      import API from "!../../../../../../apps/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../../../../apps/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../../../../../apps/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../../../../apps/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../../../../apps/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../../../../apps/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../../../../apps/node_modules/css-loader/dist/cjs.js!./callout.css";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../../../../apps/node_modules/css-loader/dist/cjs.js!./callout.css";
       export default content && content.locals ? content.locals : undefined;
